import { QueryControl } from './QueryControl';

let query = null;

export const setQuery = ( initialState ) => { 
    query = QueryControl( initialState );
}
export const getQuery = () => {
    return query;
}